import { FinancialConditionPeriodicity, FinancialConditionType } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { FileAndType } from 'services/FileService';
import { Reducer, SirenDictionnaryType, sirenStatePatcher } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const changeFinancialConditionInitialState = {
    contractIds: [] as string[],
    effectiveDate: undefined as Date | undefined,
    effectiveDay: undefined as string | undefined,
    financialConditionType: FinancialConditionType.EffectiveDate as FinancialConditionType,
    financialConditionPeriodicity: undefined as FinancialConditionPeriodicity | undefined,
    commentary: undefined as string | undefined,
    lastFinancialStatementFile: undefined as File | undefined,
    lastVatStatementsFile: undefined as File | undefined,
    files: [] as FileAndType[],
    optionalCommentary: '' as string,
    request: {
        isFetching: false,
    } as ApiRequest<string[]>,
} as const;

type ChangeFinancialConditionState = typeof changeFinancialConditionInitialState;
export const sirenChangeFinancialConditionInitialState: SirenDictionnaryType<ChangeFinancialConditionState> = {};

export const ChangeFinancialConditionReducer: Reducer<SirenDictionnaryType<ChangeFinancialConditionState>> = (state = sirenChangeFinancialConditionInitialState, action) => {
    switch (action.type) {
        case '@CUSTOMER_SERVICE/CHANGE/FINANCIAL_CONDITION/SET_FORM_VALUE':
            return sirenStatePatcher(state, action.payload.siren, {
                contractIds: action.payload.contractIds,
                effectiveDate: action.payload.effectiveDate,
                effectiveDay: action.payload.effectiveDay,
                financialConditionType: action.payload.financialConditionType,
                financialConditionPeriodicity: action.payload.financialConditionPeriodicity,
                commentary: action.payload.commentary,
                lastFinancialStatementFile: action.payload.lastFinancialStatementFile,
                lastVatStatementsFile: action.payload.lastVatStatementsFile,
                files: action.payload.files,
                optionalCommentary: action.payload.optionalCommentary,
            });
        case '@CUSTOMER_SERVICE/CHANGE/FINANCIAL_CONDITION/SUBMIT':
            return sirenStatePatcher(state, action.payload.siren, {
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: true,
                },

            });
        case '@CUSTOMER_SERVICE/CHANGE/FINANCIAL_CONDITION/SUBMIT_SUCCESS':
            return sirenStatePatcher(state, action.payload.siren, {
                ...changeFinancialConditionInitialState,
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: false,
                },
            });
        case '@CUSTOMER_SERVICE/CHANGE/FINANCIAL_CONDITION/SUBMIT_FAILURE':
            return sirenStatePatcher(state, action.payload.siren, {
                request: {
                    ...state[action.payload.siren]?.request,
                    isFetching: false,
                },
            });
        default:
            return state;
    }
};
